import { ReplyDynamicVariablesComponent } from "./reply-dynamic-variables/reply-dynamic-variables.component";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { FeaturesByPlanService } from "src/app/services/features-by-plan/features-by-plan.service";
import { SubFeatures } from "src/app/services/features-by-plan/interface/common";
import {
  ReviewStructure,
  REVIEW_SUBFEATURES,
} from "src/app/services/features-by-plan/interface/reviews";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";
import { AlertService } from "../../services/alert.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-reply-templates",
  templateUrl: "./reply-templates.component.html",
  styleUrls: ["./reply-templates.component.scss"],
})
export class ReplyTemplatesComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  reviewTemplateForm: FormGroup;
  allTemplates: any = [];
  review_template_types: any = [];
  isValidFormSubmitted: boolean = true;
  button_name: String;
  button_image: any;
  closeResult: string;
  template_id: String;
  default_template_select_p: String;
  default_template_select_n: String;
  default_template_select_c: String;
  selected_template_id_p: String;
  selected_template_id_n: String;
  selected_template_id_c: String;
  showhidedefault: boolean;
  permissions: any;

  @ViewChild("input1", { read: ElementRef }) private _inputElement: ElementRef;
  is_reviews_blocked: any;
  reviews_warning_text: any = "";
  isCustomTemplatesAvailable: boolean;
  zceppaTempLen: number;
  customTempLen: number = 0;
  reviewStructure: ReviewStructure = {
    custom_reply_template: [
      "feature_reviews",
      REVIEW_SUBFEATURES.custom_reply_template,
      "is_applicable",
    ],
    zceppa_reply_template: [
      "feature_reviews",
      REVIEW_SUBFEATURES.zceppa_reply_template,
      "is_applicable",
    ],
    custom_reply_template_count: [
      "feature_reviews",
      REVIEW_SUBFEATURES.custom_reply_template,
      "count",
      [this.customTempLen],
    ],
  };
  zceppaTemplates: any[] = [];
  customTemplates: any[] = [];
  selectedTemplate: any = null;
  @ViewChild(ReplyDynamicVariablesComponent)
  dynamicVariableSectionControl: ReplyDynamicVariablesComponent;
  predefinedVariables: any[] = [];
  dynamicVariables = {};
  objectKeys = Object.keys;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private alertService: AlertService,
    private featuresByPlan: FeaturesByPlanService
  ) {}

  async getFeatures() {
    let reviewFeatures: SubFeatures = await this.featuresByPlan.getFeatures(
      "feature_reviews"
    );
    this.isCustomTemplatesAvailable =
      reviewFeatures.plan_subfeatures.custom_reply_template.is_applicable;
    return;
  }

  get outlet_id() {
    return this.storage.get("outlet_id");
  }

  ngOnInit() {
    this.loading = true;
    this.getFeatures();
    let res: Response;
    this.setDefaultTemplates();
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.reviewTemplateForm = this.formBuilder.group({
      review_title: ["", Validators.compose([Validators.required])],
      review_content: ["", Validators.compose([Validators.required])],
      reply_type: [""],
      template_id: [""],
      set_default: [""],
    });
    this.getPredefinedVariables();

    setTimeout(() => {
      this.commonDataService();
    }, 1000);
  }

  getPredefinedVariables() {
    this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.GET_PREDEFINED_VARIABLES(this.outlet_id),
    }).subscribe((res) => {
      if (res.code == 200) {
        let predefinedVariables: Array<any> = res.data;
        this.predefinedVariables = predefinedVariables;
        this.predefinedVariables.forEach((element: any) => {
          element.variable_name = element.label;
          element.variable_value = element.value;
        });
      }
    });
  }
  get getContent() {
    return this.reviewData.review_content.value;
  }
  onType() {
    this.setDynamicVariables(this.reviewData.review_content.value);
  }
  setDynamicVariables(contentValue: string) {
    this.dynamicVariableSectionControl.selectedTemplate =
      this.selectedTemplate || null;
    this.dynamicVariables =
      this.dynamicVariableSectionControl.setDynamicVariables(contentValue);
  }
  private createDynamicVariablePayload() {
    return this.dynamicVariableSectionControl.createDynamicVariablePayload();
  }
  private isInValidDynamicVariable() {
    return this.dynamicVariableSectionControl.isInValidDynamicVariable();
  }
  emptyDynamicVariable() {
    this.dynamicVariables = {};
  }

  get reviewData() {
    return this.reviewTemplateForm.controls;
  }

  setDefaultTemplates() {
    let res: any;
    const setup_value = this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id)
    );
    setup_value.subscribe((data: Response) => {
      this.loading = false;
      res = data;
      this.default_template_select_p =
        res.data["default_reply_positive_template"];
      this.default_template_select_n =
        res.data["default_reply_negative_template"];
      this.default_template_select_c =
        res.data["default_reply_neutral_template"];
      this.storage.set(
        "default_template_id_p",
        res.data["default_reply_positive_template"]
      );
      this.storage.set(
        "default_template_id_n",
        res.data["default_reply_negative_template"]
      );
      this.storage.set(
        "default_template_id_c",
        res.data["default_reply_neutral_template"]
      );
    });
  }
  createReviewReplyTemplate(payload) {
    let res: Response;
    let dataService = this.HttpService.postRequest({
      customApiUrl: this.BASE_URL.SMS_REPLY_URL_V2(this.outlet_id),
      data: payload,
    });
    dataService.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        if (payload?.set_default) {
          payload.id = res.data["template_id"];
          this.setDefaultTemplateToStorage(payload);
        }
        this.toastrService.success(res.data["message"]);
        this.emptyFields();
        this.commonDataService();
        this.showSuccess(res.data["message"]);
      }
    );
  }

  updateReviewReplyTemplate(payload) {
    let res: Response;
    let dataService = this.HttpService.putRequest({
      customApiUrl: this.BASE_URL.SMS_REPLY_URL_UPDATE_V2(
        this.outlet_id,
        payload?.id
      ),
      data: payload,
    });
    dataService.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.selected_template_id_p = undefined;
        this.selected_template_id_n = undefined;
        this.selected_template_id_c = undefined;

        this.setDefaultTemplateToStorage(payload);
        this.toastrService.success(res.data["message"]);
        this.emptyFields();
      }
    );
  }

  setDefaultTemplateToStorage(payload): void {
    const { id, type, set_default } = payload;

    const data_json = {
      template_id: id,
      type,
    };

    const removeFromStorage = (key: string): void => {
      this.storage.remove(key);
    };

    const previouslySelected = [
      this.default_template_select_p,
      this.default_template_select_n,
      this.default_template_select_c,
    ].includes(id);

    if (!set_default) {
      if (previouslySelected) {
        const UNSELECT_DEFAULT_REPLY_URL = this.BASE_URL.UNSELECT_DEFAULT_REPLY(
          this.outlet_id,
          id
        );
        this.HttpService.putRequest({
          customApiUrl: UNSELECT_DEFAULT_REPLY_URL,
          data: data_json,
        }).subscribe(
          () => {
            removeFromStorage(
              `default_template_id_${type.charAt(0).toLowerCase()}`
            );
            this.commonDataService();
            this.setDefaultTemplates();
          },
          (error) => {
            this.showError(error.error.message);
          }
        );
        return;
      }

      this.commonDataService();
      this.setDefaultTemplates();
      return;
    }

    const REVIEW_REQ_UPD_REPLY_TEMP_URL_V2 =
      this.BASE_URL.REVIEW_REQ_UPD_REPLY_TEMP_URL_V2(this.outlet_id);
    this.HttpService.putjson(
      REVIEW_REQ_UPD_REPLY_TEMP_URL_V2 + id,
      data_json
    ).subscribe(
      (res: Response) => {
        const { type, id } = payload;

        if (res.code !== 200) {
          return;
        }

        switch (type) {
          case "POSITIVE":
            this.storage.set("default_template_id_p", id);
            this.default_template_select_p = id;
            break;
          case "NEGATIVE":
            this.storage.set("default_template_id_n", id);
            this.default_template_select_n = id;
            break;
          case "NEUTRAL":
            this.storage.set("default_template_id_c", id);
            this.default_template_select_c = id;
            break;
        }

        this.commonDataService();
        this.setDefaultTemplates();
      },
      (error) => {
        this.showError(error.error.message);
      }
    );
  }

  submitReviewReplyTemplate(From: FormGroup) {
    this.isValidFormSubmitted = false;
    let isDynValueInvalid = this.isInValidDynamicVariable()?.value;
    let isDynLabelInvalid = this.isInValidDynamicVariable()?.label;
    if (
      this.reviewTemplateForm.invalid ||
      isDynValueInvalid ||
      isDynLabelInvalid
    ) {
      if (isDynLabelInvalid) {
        this.toastrService.error("Dynamic Variable name cannot be empty");
      }
      return;
    }

    this.isValidFormSubmitted = true;
    let dynamicVariablePayload = this.createDynamicVariablePayload();
    const {
      review_title,
      review_content,
      reply_type,
      template_id,
      set_default,
    } = From.getRawValue();

    if (From.controls.template_id.value === "") {
      const form_data = {
        title: review_title,
        content: review_content,
        set_default: set_default,
        type: reply_type ? reply_type : "NEUTRAL",
        ...dynamicVariablePayload,
      };
      this.createReviewReplyTemplate(form_data);
    } else {
      const form_data = {
        title: review_title,
        content: review_content,
        type: reply_type,
        id: template_id,
        set_default: set_default,
        ...dynamicVariablePayload,
      };
      this.updateReviewReplyTemplate(form_data);
    }
  }

  onSelectTemplate(template) {
    this.reviewTemplateForm.controls["review_title"].disable();
    this.selectedTemplate = template;
    this.selected_template_id_p = template.id;
    this.selected_template_id_n = template.id;
    this.selected_template_id_c = template.id;

    const templateValues = {
      review_title: template.title,
      review_content: template.content,
      reply_type: template.type,
      template_id: template.id,
      set_default: template.id,
    };

    if (
      this.selected_template_id_p === this.default_template_select_p ||
      this.selected_template_id_n === this.default_template_select_n ||
      this.selected_template_id_c === this.default_template_select_c
    ) {
      this.reviewTemplateForm.setValue(templateValues);
    } else {
      this.reviewTemplateForm.setValue({
        ...templateValues,
        set_default: "",
      });
    }

    const reviewContentControl =
      this.reviewTemplateForm.controls["review_content"];
    if (template.default) {
      reviewContentControl.disable();
      this.reviewTemplateForm.controls["reply_type"].disable();
    } else {
      reviewContentControl.enable();
      this.reviewTemplateForm.controls["reply_type"].enable();

      const isSetAsDefault =
        this.reviewTemplateForm.controls["set_default"].value;
      this.reviewTemplateForm.controls["reply_type"][
        isSetAsDefault ? "disable" : "enable"
      ]();
    }

    this.setDynamicVariables(template.content);
    this.button_name = "Save";
    this.button_image = "assets/images/save-file-option.svg";
  }

  onDeleteTemplate(templateId) {
    this.template_id = templateId;
    this.alertService
      .alertWithDeleteImage(
        "Delete Template",
        "Are you sure you want to delete the template?",
        "Delete"
      )
      .then((data) => {
        if (data.isConfirmed) {
          this.deleteTemplate();
        }
      });
  }

  deleteTemplate() {
    let res: Response;
    const dataService = this.HttpService.delete(
      this.BASE_URL.SMS_REPLY_URL_DELETE_V2(this.outlet_id) + this.template_id,
      this.template_id
    );
    dataService.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.modalService.dismissAll("content");
        this.showSuccess("Template deleted successfully");
        this.commonDataService();
        this.emptyFields();
      }
    );
  }

  async commonDataService() {
    this.loading = true;
    const response = await this.HttpService.get(
      this.BASE_URL.SMS_REPLY_URL_GET_WP_V2(this.outlet_id)
    ).toPromise();
    this.loading = false;
    const { permissions, templates, template_types } = response.data.response;

    this.permissions = permissions;
    this.review_template_types = template_types;

    const trueIndexTemplates: any[] = [];
    const falseIndexTemplates: any[] = [];
    templates.forEach((template: any) => {
      if (template.default === true) {
        trueIndexTemplates.push(template);
      } else {
        falseIndexTemplates.push(template);
      }
    });
    this.zceppaTemplates = trueIndexTemplates;
    this.customTemplates = falseIndexTemplates;

    this.setDefaultTemplates();
    this.emptyFields();
  }
  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modalreviewadd" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  emptyFields() {
    this.reviewTemplateForm.controls["review_title"].enable();
    this.reviewTemplateForm.controls["review_content"].enable();
    this.selected_template_id_p = undefined;
    this.selected_template_id_n = undefined;
    this.selected_template_id_c = undefined;
    this.selectedTemplate = null;
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.reviewTemplateForm.setValue({
      review_title: "",
      review_content: "",
      reply_type: "NEUTRAL",
      template_id: "",
      set_default: "",
    });
    this.emptyDynamicVariable();
  }

  onSelectDynamicVariableFromModal(variableData) {
    let contentData = this.reviewTemplateForm.controls["review_content"].value;
    let updatedData = contentData + " " + variableData?.variable_name;
    this.reviewTemplateForm.patchValue({
      review_content: updatedData,
    });
    this.onType();
  }

  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  showError(msg: string) {
    this.toastrService.error(msg);
  }
}
